import { type MaterialType } from '$/services/usecases/materials/mapper/materials';

let tracking: {
  trackEvent(category: string, action: string, name?: string): void;
} = { trackEvent: () => undefined };

export const configureCollectionTracking = (config: typeof tracking) => {
  tracking = config;
};

export const trackCollectionEvent = (
  category: string,
  action: string,
  name?: string,
) => tracking.trackEvent(category, action, name);

export const mapCollectionFilterToTrackingAction = (
  group: string,
  activeFilterType?: MaterialType,
) => {
  switch (group) {
    case 'producer':
      return 'Producer';
    case 'collection':
      return 'Collection';
    case 'color':
    case 'colorRanges':
      return 'Colorgroup';
    case 'SEARCH_CRITERIA_20':
      return 'Productgroup';
    case 'SEARCH_CRITERIA_39':
      return activeFilterType === 'floor_texture'
        ? 'Floor_Colorintensity'
        : 'Wallpaper_Colorintensity';
    case 'SEARCH_CRITERIA_36':
      return activeFilterType === 'floor_texture'
        ? 'Floor_Design'
        : 'Wallpaper_Design';
    case 'SEARCH_CRITERIA_37':
      return 'Floor_Material';
    case 'SEARCH_CRITERIA_38':
      return 'Floor_Use';
    default:
      return null;
  }
};
